import { useAuthContext } from 'state/auth';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

const useIsSignUpAfterCart = (): boolean => {
  const { isAuthenticated } = useAuthContext();
  const enableSignupAfterCart = useFlag(LaunchDarklyFlag.ENABLE_MOVE_SIGNUP_AFTER_CART);
  return !isAuthenticated && enableSignupAfterCart;
};

export default useIsSignUpAfterCart;
